export enum PerformancePersonalReviewStatusEnum {
    INPUT = 'input',
    DISCUSSION = 'discussion',
    REVIEW = 'review',
    COMPLETED = 'completed',
    CANCELED = 'canceled',
}
